import { Application } from "../../../../MPP-Common-SPA/utils/generator/applicationModels";

// May be something similar in public portal.
const getStepData = (application: Partial<Application> | null) => {
  return application?.applicationData?.applicationData?.stepData || {};
};

const ensureDate = (dateValue: any, defaultDate = new Date()): Date => {
  if (typeof dateValue === "string") {
    return new Date(dateValue);
  }
  return dateValue instanceof Date ? dateValue : defaultDate;
};

// Section initializers
const getPersonalInformationInitialValues = (stepData: any) => ({
  givenName: stepData.PersonalInformation?.givenName || "",
  middleName: stepData.PersonalInformation?.middleName || "",
  surname: stepData.PersonalInformation?.surname || "",
  fullName: stepData.PersonalInformation?.fullName || "",
  dob: ensureDate(stepData.PersonalInformation?.dob),
  gender: stepData.PersonalInformation?.gender || "",
  streetAddressLine1: stepData.PersonalInformation?.streetAddressLine1 || "",
  streetAddressLine2: stepData.PersonalInformation?.streetAddressLine2 || "",
  locality: stepData.PersonalInformation?.locality || "",
  province: stepData.PersonalInformation?.province || "",
  postalCode: stepData.PersonalInformation?.postalCode || "",
  country: stepData.PersonalInformation?.country || "",
  email: stepData.PersonalInformation?.email || "",
  mobile: stepData.PersonalInformation?.mobile || "",
  phone: stepData.PersonalInformation?.phone || "",
});

const getEvacuationLocationInitialValues = (coordinates: any) => ({
  mapLat: coordinates ? coordinates[1] : 0,
  mapLng: coordinates ? coordinates[0] : 0,
  acceptDeclaration: true,
  eligibleEvacuationLocation: true,
});

const getTemporaryContactInformationInitialValues = (
  stepData: any,
  application: Partial<Application> | null
) => ({
  returnedToHome: stepData.TemporaryContactInfo?.returnedToHome || "",
  usePersonalNumber: stepData.TemporaryContactInfo?.usePersonalNumber || false,
  tempPhoneNumber:
    stepData.TemporaryContactInfo?.tempPhoneNumber || application?.mobile || "",
});

const getFirstNationStatusInitialValues = (stepData: any) => ({
  isIndigenous: stepData.FirstNationStatus?.isIndigenous || "",
  band: stepData.FirstNationStatus?.band || "",
  family: stepData.FirstNationStatus?.family || "",
  position: stepData.FirstNationStatus?.position || "",
  FNIHB: stepData.FirstNationStatus?.FNIHB || "",
  livesOnReserve: stepData.FirstNationStatus?.livesOnReserve || "",
});

const getFamilyMembersInitialValues = (stepData: any) => ({
  familyMembers: (stepData.FamilyMembers?.familyMembers || []).map(
    (member: any) => ({
      ...member,
      dob: ensureDate(member.dob),
    })
  ),
  acceptLegalRepresentative:
    stepData.FamilyMembers?.acceptLegalRepresentative ?? true,
});

const getPaymentInformationInitialValues = (verificationStatus: string) => {
  return (
    verificationStatus !== "1" && {
      receivePayment: "",
      usePersonalEmail: false,
      email: "",
      confirmEmail: "",
      receiveETransfer: "",
      usePersonalNumber: false,
      mobile: "",
      confirmMobile: "",
      institutionNumber: "",
      transitNumber: "",
      bankAccount: "",
      confirmBankAccount: "",
      bankName: "",
    }
  );
};

export const initialValues = (
  application: Partial<Application> | null,
  programId: string,
  programEventCode: string,
  coordinates: any,
  verificationStatus: string
) => {
  const stepData = getStepData(application);

  return {
    verificationStatus: application?.verificationStatus || 1,
    programId,
    applicationType: programEventCode,
    PersonalInformation: getPersonalInformationInitialValues(stepData),
    EvacuationLocation: getEvacuationLocationInitialValues(coordinates),
    TemporaryContactInformation: getTemporaryContactInformationInitialValues(
      stepData,
      application
    ),
    FirstNationStatus: getFirstNationStatusInitialValues(stepData),
    FamilyMembers: getFamilyMembersInitialValues(stepData),
    PaymentInformation: getPaymentInformationInitialValues(verificationStatus),
  };
};
